import React, { useState, useEffect } from 'react';
import _get from 'lodash/get';
import { client } from 'cccisd-apollo';
import { DeploymentPlayer } from 'cccisd-laravel-assignment';
import Loader from 'cccisd-loader';
import metricsPawnQuery from './metricsPawn.graphql';

export const TFH_DEPLOYMENT_HANDLE = 'tfhProgram';

const Fortress = window.cccisd.fortress;

const TfhProgram = () => {
    const isNeedMetricsPawn = ['tfhParent', 'tfhChild'].includes(Fortress.user.acting.role.handle);
    const [metricsPawnInfo, setMetricsPawnInfo] = useState(null);

    useEffect(() => {
        async function getMetricsPawnInfo() {
            const resp = await client.query({
                query: metricsPawnQuery,
                variables: {
                    groupId: Fortress.user.acting.group.id,
                    groupHash: Fortress.user.acting.group.random_hash,
                },
                fetchPolicy: 'cache-first', // unlikely to change
            });

            let info = _get(resp, 'data.groups.tfhClass.childRoles.metricspawn.pawn', {}) || {};
            if (!info.pawnId) {
                console.error("Could not get metrics pawn ID for current user's group");
                info = null;
            }

            setMetricsPawnInfo(info);
        }

        if (isNeedMetricsPawn) {
            getMetricsPawnInfo();
        }
    }, []);

    if (isNeedMetricsPawn && (!metricsPawnInfo?.pawnId || !metricsPawnInfo?.pawnHash)) {
        return <Loader loading />;
    }

    return (
        <DeploymentPlayer
            pawnId={isNeedMetricsPawn ? metricsPawnInfo.pawnId : Fortress.user.acting.id}
            pawnHash={isNeedMetricsPawn ? metricsPawnInfo.pawnHash : Fortress.user.acting.random_hash}
            deploymentHandle={TFH_DEPLOYMENT_HANDLE}
            // allow Coaches, Supervisors, Ubers to skip ahead
            {...(!isNeedMetricsPawn ? { flowProps: { isPresenterMode: true } } : {})}
        />
    );
};

export default TfhProgram;
